import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: fit-content;
  background-color: ${({ theme }) => theme.neutral_200};
  padding: 25px 40px;
  border-radius: 10px;
  gap: 20px;
`;

export const Section = styled.div<{
  $limitedSize?: boolean;
  $alignEnd?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20px;

  ${({ $limitedSize }) => $limitedSize && 'max-width: 260px;'}
  ${({ $alignEnd }) => $alignEnd && 'align-items: flex-end;'}
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
